<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "relatorio-ruptura") {
            next({ name: "relatorio-ruptura-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "relatorio-ruptura") {
            this.$router.push({ name: "relatorio-ruptura-list" });
        }
    },
};
</script>